export default {
  root: {
    '&:focus': {
      outline: 'none'
    }
  }
};



// WEBPACK FOOTER //
// ./src/atoms/Link/LinkMenuItem/styles.js